import { render, staticRenderFns } from "./EditarContenido.vue?vue&type=template&id=5f1ef9b4"
import script from "./EditarContenido.vue?vue&type=script&lang=js"
export * from "./EditarContenido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports